import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button,  Box, Chip, Grid,
  // FormControl, InputLabel, Select,
  // MenuItem, Typography, CircularProgress,
} from '@mui/material';
import { useEffect, useState } from 'react';

export default function AddLeadModal({ open, onClose, leadData, onSave, leadScoreGenLoading }) {
  const [form, setForm] = useState({ ...leadData });
  const [errors, setErrors] = useState({});
  const [newTag, setNewTag] = useState('');

  /* on mount load lead form */
  useEffect(() => {
    setForm({ ...leadData, tags: []}); // , status: leadData?.status || 'new',
    setErrors({});
    setNewTag('');
  }, [leadData]);

  /* validate form */
  const validate = (updatedForm = form) => {
    const newErrors = {};
    if (!updatedForm.firstName) newErrors.firstName = 'First Name is required';
    if (!updatedForm.lastName) newErrors.lastName = 'Last Name is required';
    if (!updatedForm.email) newErrors.email = 'Email is required';
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(updatedForm.email)) {
      newErrors.email = 'Invalid email format';
    }
    if (!updatedForm.company) newErrors.company = 'Company is required';
    if (!updatedForm.jobTitle) newErrors.jobTitle = 'Job Title is required';
    if (!updatedForm.industry) newErrors.industry = 'Industry is required';
    if (!updatedForm.companySize) newErrors.companySize = 'Company Size is required';
    if (!updatedForm.website) newErrors.website = 'Website is required';
    if (!updatedForm.phone) newErrors.phone = 'Phone is required';
    if (!updatedForm.linkedin) newErrors.linkedin = 'linkedIn is required';
    if (!updatedForm.country) newErrors.country = 'Country is required';
    if (!updatedForm.state) newErrors.state = 'State is required';
    if (!updatedForm.city) newErrors.city = 'City is required';
    if (!updatedForm.tags || updatedForm.tags.length === 0) {
      newErrors.tags = 'At least one tag is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddTag = () => {
    const tag = newTag.trim();
    if (
      tag &&
      !form.tags.includes(tag) &&
      (form.tags.length < 5)
    ) {
      const updatedTags = [...form.tags, tag];
      const updatedForm = { ...form, tags: updatedTags };
      setForm(updatedForm);
      validate(updatedForm);
    }
    setNewTag('');
  };

  /* on Enter button click after tag name entered - add tag*/
  const handleTagKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
    //  validate(form);
  };

  const handleDeleteTag = (tagToDelete) => {
    const updatedTags = form.tags.filter((tag) => tag !== tagToDelete);
    const updatedForm = { ...form, tags: updatedTags };
    setForm(updatedForm);
    validate(updatedForm);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...form, [name]: value };
    setForm(updatedForm);
    validate(updatedForm); // live validation
  };

  const handleSubmit = () => {
    if (validate()) {
      onSave(form); 
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth
    slotProps={{ paper :{
          sx: {
            borderRadius: 2,  
          },
        } 
    }}
    >
      <DialogTitle>Add Lead</DialogTitle>
      {/* {!leadScoreGenLoading &&  <> */}
      <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Grid container spacing={2}>
          {[
            { name: 'firstName', label: 'First Name', maxLength: 100 },
            { name: 'lastName', label: 'Last Name', maxLength: 100 },
            { name: 'email', label: 'Email', maxLength: 100 },
            { name: 'company', label: 'Company', maxLength: 100 },
            { name: 'jobTitle', label: 'Job Title', maxLength: 100 },
            { name: 'industry', label: 'Industry', maxLength: 100 },
            { name: 'companySize', label: 'Company Size', maxLength: 30 },
            { name: 'website', label: 'Website URL', maxLength: 300 },
            { name: 'phone', label: 'Phone', maxLength: 13 },
            { name: 'linkedin', label: 'LinkedIn URL', maxLength: 300 },
            { name: 'city', label: 'City', maxLength: 100 },
            { name: 'state', label: 'State', maxLength: 100 },
            { name: 'country', label: 'Country', maxLength: 100 },
          ].map(({ name, label, maxLength }) => (
            <Grid size={{ xs: 12, sm: 6 }} key={name}>
              <TextField
                fullWidth
                name={name}
                label={label}
                value={form[name] || ''}
                onChange={handleChange}
                error={!!errors[name]}
                helperText={errors[name]}
                size="small"
                slotProps={{ htmlInput: { maxLength } }}
              />
            </Grid>
          ))}
          <Grid size={{ xs: 12, sm: 6 }}>
            {/* <FormControl size='small' fullWidth>
            <InputLabel>Status</InputLabel>
            <Select name="status" label="Status"  value={form.status || ''} onChange={handleChange}>
              <MenuItem value="new">New</MenuItem>
              <MenuItem value="contacted">Contacted</MenuItem>
              <MenuItem value="converted">Converted</MenuItem>
            </Select>
          </FormControl> */}
          </Grid>
          {/* Tags Field */}
          <Grid size={{ xs: 12, sm: 12 }} >
            <TextField
              label={(form.tags?.length || 0) >= 5 ? " Maximum 5 tags per lead" : "Tags"}
              placeholder="Type tag name and press Enter"
              fullWidth
              size="small"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
              onKeyDown={handleTagKeyDown}
              disabled={(form.tags?.length || 0) >= 5} // Disable after 5 tags
              error={!!errors.tags}
              helperText={errors.tags}
              slotProps={{ htmlInput: { maxLength: 30 } }}
            />
            <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {(form.tags || []).map((tag) => (
                <Chip
                  key={tag}
                  label={tag}
                  onDelete={() => handleDeleteTag(tag)}
                  color="primary"
                  size="small"
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button
          onClick={handleSubmit}
          disabled={
            !form.firstName ||
            !form.lastName ||
            !form.email ||
            (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email)) ||
            !form.company ||
            !form.jobTitle ||
            !form.industry ||
            !form.companySize ||
            !form.website ||
            !form.phone ||
            !form.linkedin ||
            !form.country ||
            !form.state ||
            !form.city ||
            form.tags.length === 0
            //!form.status 

          }
          variant="contained"
          loading={leadScoreGenLoading}
          loadingPosition='end'
        >

          {leadScoreGenLoading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
      {/* </>} */}
    {/* {leadScoreGenLoading && 
      <Box sx={{ display: 'flex', alignItems:'center', p:2,m:2 }}>
      <CircularProgress /><Typography variant='body1' sx={{mx:4}}>AI Score Calculating for the lead......</Typography>
      </Box>
      
      } */}
    </Dialog>
  );
}
